import { object, number } from 'yup';
import { errorMessages } from 'screens/Mutations/constants';

export const collateralSchema = object().shape({
  distributionValue: number().typeError(errorMessages.number).required(errorMessages.required),
  marketValue: number().typeError(errorMessages.number).required(errorMessages.required),
  valuationCosts: number().typeError(errorMessages.number).required(errorMessages.required),
});
